/**
 * containerStyle: Modal grid's containerStyle    object
 * onClose: Modal grid's colse event    functions(필수)
 * name: Modal grid's name    string
 * conditions: Modal grid's conditions    object array
 *     ex) [
				{
					type: "input",
					name: "품목",
					value: gridModalInputs.inputValue,
					onChange: (e) => {
						setGridModalInputs({
							...gridModalInputs,
							inputValue: e.target.value,
						});
					},
					onClick: () => {},
					onKeyDown: () => {},
				},
				{
					type: "radio",
					items: [
						{ value: "0", name: "value1" },
						{ value: "1", name: "value2", checked: true },
						{ value: "2", name: "value3" },
					],
					value: gridModalInputs.radioValue,
					onChange: (e) => {
						setGridModalInputs({
							...gridModalInputs,
							radioValue: e.target.value,
						});
					},
				},
				{
					type: "combo",
					name: "combo",
					combos: [
						{ value: "0", label: "java" },
						{ value: "1", label: "javaScript" },
						{ value: "2", label: "C#" },
						{ value: "3", label: "Phyton" },
					],
					value: gridModalInputs.comboValue,
					onChange: (e) => {
						setGridModalInputs({
							...gridModalInputs,
							comboValue: e.value,
						});
					},
				},
				{
					type: "dates",
					selected: gridModalInputs.datesValue,
					onChange: (e) => {
						setGridModalInputs({
							...gridModalInputs,
							datesValue: e,
						});
					},
				},
				{
					type: "check",
					name: "check",
					value: gridModalInputs.checkValue,
					onChange: (e) => {
						setGridModalInputs({
							...gridModalInputs,
							checkValue: e.target.checked,
						});
					},
				},
				{
					type: "groupCheck",
					items: [
						{
							name: "InGi",
							value: gridModalInputs.groupCheckValue1,
							onChange: (e) => {
								setGridModalInputs({
									...gridModalInputs,
									groupCheckValue1: e.target.checked,
								});
							},
						},
						{
							name: "InGi2",
							value: gridModalInputs.groupCheckValue2,
							onChange: (e) => {
								setGridModalInputs({
									...gridModalInputs,
									groupCheckValue2: e.target.checked,
								});
							},
						},
					],
					gubun: 1,
				},
			]
 * gridDefaultColDef: Modal grid's gridDefaultColDef    object
 * gridColumn: Modal grid's gridColumn    object array
 * gridRowData: Modal grid's gridRowData    object array
 * gridRowSelection: Modal grid's gridRowSelection    string
 *     options: "single", "multiple"
 * gridSingleClickEdit: Modal grid's gridSingleClickEdit    boolean
 * gridOnClick: Modal grid's row click event    function
 * gridOnDoubleClick: Modal grid's row double click event   function
 * buttonName1: Modal grid's buttonName1    string
 * buttonName2: Modal grid's buttonName2    string
 * execLogic: Modal grid's exec logic event    function
 *
 */

import React, { useEffect } from "react";
import { ko } from "date-fns/esm/locale";
/** Components Import */
import Card from "./Card_wrap";
import Section from "./Section";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BasicInput from "./Input_Basic";
import Datepicker from "react-datepicker";
import BasicRadio from "./Radio_Basic";
import BasicCheckbox from "./Checkbox_Basic";
import GroupCheckbox from "./Checkbox_Group";
import BasicButton from "./Button_Basic";
import IndexedDb from "../Services/IndexedDb/IndexedDb";
import GridFunctions from "../Services/agGrid/ag-Grid-functions";
/** Ag-grid Import */
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
/** Icons Import */
import { faClose } from "@fortawesome/free-solid-svg-icons";
import BasicCombo from "./Combo_Basic";
/** Mui Import */
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

function GridModal({
  containerStyle,
  onClose,
  name,
  conditions = [],
  gridDefaultColDef,
  gridColumn = [],
  gridRowData = [],
  gridRowSelection,
  gridSingleClickEdit,
  gridOnClick = (e) => {},
  gridOnDoubleClick = (e) => {},
  buttonName1,
  buttonName2,
  execLogic = (e) => {},
  searchLogic = (e) => {},
  addLogic = (e) => {},
  onCellValueChanged = (e) => {},
  deleteLogic = (e) => {},
  execCLosed = "1",
  notButton = "",
  gridFirstRender = (e, ref) => {},
  renderInput = (params) => {},
  gridStyle = { width: "100%", height: "500px" },
}) {
  const [lanData, setLanData] = React.useState([]);
  React.useEffect(() => {
    Init();
  }, []);
  const Init = async () => {
    let getLanData = [];

    await IndexedDb.GetAllDb("LanguageList").then((result) => {
      if (result.length > 0) {
        getLanData = result.filter((f) => f.lanType !== "MENU");
      }
    });

    setLanData(getLanData);
  };
  const gridModalRef = React.useRef();

  const CloseModal = () => {
    onClose();
  };

  const ReturnItems = (_item, _index) => {
    switch (_item.type) {
      case "input":
        return (
          <BasicInput
            containerStyle={_item.containerStyle}
            labelStyle={_item.labelStyle}
            key={_index}
            style={_item.style}
            name={_item.name}
            id={_item.id}
            placeholder={_item.placeholder}
            value={_item.value}
            onChange={(e) => {
              _item.onChange(e, gridModalRef);
            }}
            onClick={(e) => {
              _item.onClick(e, gridModalRef);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                _item.onKeyDown(e, gridModalRef);
              }
            }}
            inputMode={_item.inputMode}
            type={_item.inputType}
            disabled={_item.disabled}
          />
        );
      case "radio":
        return (
          <BasicRadio
            key={_index}
            items={_item.items}
            containerStyle={_item.containerStyle}
            inputStyle={_item.inputStyle}
            labelStyle={_item.labelStyle}
            value={_item.value}
            onChange={(e) => {
              _item.onChange(e, gridModalRef);
            }}
            gubun={_index}
            disabled={_item.disabled}
          />
        );
      case "muicombo":
        return (
          <Autocomplete
            key={_index}
            freeSolo
            id={_item.id}
            disableClearable
            sx={{ width: "200px" }}
            options={_item.combos}
            getOptionLabel={(option) => option.label || ""}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  label={"cust"}
                  InputProps={{
                    ...params.InputProps,
                    type: "search",
                  }}
                />
              );
            }}
            onChange={_item.onChange}
            onInputChange={_item.onInputChange}
            value={_item.value}
            inputValue={_item.inputValue}
            onKeyDown={_item.onKeyDown}
            onKeyUp={_item.onKeyUp}
            // multipleValue={_item.selectedValues}
          />
        );
      case "combo":
        return (
          <BasicCombo
            key={_index}
            wrapClass="input"
            containerClass="formGroup_info_combo_container"
            combos={_item.combos}
            value={_item.value}
            onChange={(e) => _item.onChange(e)}
          />
        );
      case "comboInput":
        return (
          <BasicCombo
            key={_index}
            name={_item.name}
            wrapClass={_item.wrapClass}
            containerClass="input"
            combos={_item.combos}
            value={_item.value}
            onChange={(e) => _item.onChange(e)}
          />
        );
      case "dates":
        return (
          <div key={_index} className="datepicker-custom-modal-wrap">
            {_item.labelNone === "none" ? null : (
              <label className="datepicker-custom-modal-label">
                {_item.name}
              </label>
            )}
            <Datepicker
              portalId={_item.portalId}
              className="datepicker-custom-modal-input"
              locale={ko}
              showIcon={_item.showIcon}
              selected={_item.selected}
              onChange={(e) => {
                _item.onChange(e, gridModalRef);
              }}
              dateFormat="yyyy-MM-dd"
              disabled={_item.disabled}
            />
          </div>
        );
      case "check":
        return (
          <BasicCheckbox
            key={_index}
            containerStyle={_item.containerStyle}
            inputStyle={_item.inputStyle}
            labelStyle={_item.labelStyle}
            name={_item.name}
            value={_item.value}
            onChange={_item.onChange}
            disabled={_item.disabled}
          />
        );
      case "groupCheck":
        return (
          <GroupCheckbox
            key={_index}
            items={_item.items}
            containerStyle={_item.containerStyle}
            inputStyle={_item.inputStyle}
            labelStyle={_item.labelStyle}
            gubun={_item.gubun}
          />
        );
      case "button":
        return (
          <BasicButton
            key={_index}
            style={_item.style}
            name={_item.name}
            onClick={(e) => {
              _item.onClick(e, gridModalRef);
            }}
          />
        );
    }
  };

  // Row를 선택할때마다 동작하는 Callback함수
  const onSelectionChanged = React.useCallback(() => {
    const selected = gridModalRef.current.api.getSelectedRows();
    gridOnClick(selected);
  }, []);

  const ExecLogic = (e) => {
    execLogic(e);
    if (execCLosed == "1") {
      CloseModal();
    }
  };
  const SearchLogic = (e) => {
    searchLogic(e);
    if (execCLosed == "1") {
      CloseModal();
    }
  };
  const SearchLogic1 = (e) => {
    searchLogic(e);
    if (execCLosed == "0") {
      CloseModal();
    }
  };
  const AddLogic = () => {
    gridModalRef.current.api.setRowData([{ check: "" }, ...gridRowData]);
  };
  const AddLogic1 = (e) => {
    addLogic(e);
  };
  return (
    <div className="modal-wrap">
      <div className="modal-grid-container" style={containerStyle}>
        <div className="modal-title">
          <h3>{name}</h3>
          <button type="button" onClick={CloseModal}>
            <FontAwesomeIcon className="modal-icon" icon={faClose} />
          </button>
        </div>
        <Section />
        <div className="modal-content">
          {conditions.length > 0 ? (
            <>
              <Card
                style={{ minHeight: "60px" }}
                wrapStyle={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {conditions.map((item, index) => {
                  return ReturnItems(item, index);
                })}
              </Card>
              <Section />
            </>
          ) : null}
          <Card>
            <div className="ag-theme-alpine no-scroll" style={gridStyle}>
              <AgGridReact
                ref={gridModalRef}
                animateRows={true}
                columnDefs={gridColumn}
                defaultColDef={gridDefaultColDef}
                rowData={gridRowData}
                rowSelection={gridRowSelection}
                onSelectionChanged={onSelectionChanged}
                singleClickEdit={gridSingleClickEdit}
                onCellValueChanged={onCellValueChanged}
                onRowDoubleClicked={(e) => {
                  gridOnDoubleClick(e.data, gridModalRef);
                }}
                onFirstDataRendered={(e) => {
                  gridFirstRender(e, gridModalRef);
                }}
              />
            </div>
          </Card>
        </div>
        <Section />
        <div className="modal-footer">
          {notButton == "3" ? (
            <>
              <BasicButton
                style={{ width: "100px" }}
                name={"추가"}
                onClick={AddLogic1}
              />
              <BasicButton
                style={{ width: "100px" }}
                name={buttonName1}
                onClick={ExecLogic}
              />
              <BasicButton
                style={{ width: "100px" }}
                name={buttonName2}
                onClick={SearchLogic1}
              />
              <BasicButton
                style={{ width: "100px" }}
                name={
                  lanData.length > 0
                    ? lanData.filter(
                        (f) => f.lanId === "Btn_Close" && f.lanType === "BTN"
                      )[0].lanName
                    : ""
                }
                onClick={CloseModal}
              />
            </>
          ) : notButton === "9" ? (
            <>
              <BasicButton
                style={{ width: "100px" }}
                name={
                  lanData.length > 0
                    ? lanData.filter(
                        (f) => f.lanId === "Btn_Close" && f.lanType === "BTN"
                      )[0].lanName
                    : ""
                }
                onClick={CloseModal}
              />
            </>
          ) : notButton != "0" ? (
            <>
              <BasicButton
                style={{ width: "100px" }}
                name={buttonName1}
                onClick={() => ExecLogic(gridModalRef)}
              />
              <BasicButton
                style={{ width: "100px" }}
                name={
                  lanData.length > 0
                    ? lanData.filter(
                        (f) => f.lanId === "Btn_Close" && f.lanType === "BTN"
                      )[0].lanName
                    : ""
                }
                onClick={CloseModal}
              />
            </>
          ) : (
            <>
              <BasicButton
                style={{ width: "100px" }}
                name={"추가"}
                onClick={AddLogic}
              />
              <BasicButton
                style={{ width: "100px" }}
                name={buttonName1}
                onClick={ExecLogic}
              />
              <BasicButton
                style={{ width: "100px" }}
                name={"삭제"}
                onClick={deleteLogic}
              />
              <BasicButton
                style={{ width: "100px" }}
                name={
                  lanData.length > 0
                    ? lanData.filter(
                        (f) => f.lanId === "Btn_Close" && f.lanType === "BTN"
                      )[0].lanName
                    : ""
                }
                onClick={CloseModal}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

GridModal.defaultProps = {
  gridDefaultColDef: {
    flex: 1,
    minWidth: 100,
    resizable: true,
    sortable: true,
    filter: true,
    floatingFilter: true,
  },
  gridRowSelection: "multiple",
  gridSingleClickEdit: false,
};

export default GridModal;
